import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../lib/i18n';

export default function Register() {
  const { t } = useI18n();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success(t.auth.welcome);
      navigate('/dashboard');
    } catch (err) {
      toast.error(err?.response?.data?.detail || t.common.error);
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <h1 className="font-display text-3xl md:text-4xl font-medium tracking-tight">{t.auth.join}</h1>
        <p className="mt-2 text-muted-foreground">{t.auth.register}</p>

        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="text-xs uppercase tracking-widest text-muted-foreground font-medium">{t.auth.name}</label>
            <input type="text" required value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name-input"
              className="mt-2 w-full px-4 py-3 rounded-xl bg-background border border-border focus:border-primary focus:ring-1 focus:ring-primary outline-none" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-muted-foreground font-medium">{t.auth.email}</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email-input"
              className="mt-2 w-full px-4 py-3 rounded-xl bg-background border border-border focus:border-primary focus:ring-1 focus:ring-primary outline-none" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-muted-foreground font-medium">{t.auth.password}</label>
            <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password-input"
              className="mt-2 w-full px-4 py-3 rounded-xl bg-background border border-border focus:border-primary focus:ring-1 focus:ring-primary outline-none" />
            <p className="mt-1.5 text-xs text-muted-foreground">Min 8 caratteri</p>
          </div>
          <button type="submit" disabled={loading} data-testid="register-submit-btn"
            className="w-full inline-flex items-center justify-center px-6 py-3 rounded-full bg-primary text-primary-foreground font-medium hover:opacity-90 disabled:opacity-50 transition-opacity">
            {loading ? t.common.loading : t.auth.submit_register}
          </button>
        </form>

        <div className="my-6 flex items-center gap-3">
          <div className="h-px flex-1 bg-border" />
          <span className="text-xs uppercase tracking-widest text-muted-foreground">{t.auth.or}</span>
          <div className="h-px flex-1 bg-border" />
        </div>

        <button onClick={googleLogin} data-testid="register-google-btn"
          className="w-full inline-flex items-center justify-center gap-3 px-6 py-3 rounded-full border border-border font-medium hover:bg-secondary transition-colors">
          <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
          {t.auth.with_google}
        </button>

        <p className="mt-8 text-sm text-muted-foreground text-center">
          {t.auth.have_account} <Link to="/login" className="text-foreground font-medium hover:underline">{t.nav.login}</Link>
        </p>
      </div>
    </div>
  );
}
